// extracted by mini-css-extract-plugin
export default {"center":"CampaignCreatePage_center__0gXju","fullCenter":"CampaignCreatePage_fullCenter__4oFXz","float":"CampaignCreatePage_float__I7LHN","uu":"CampaignCreatePage_uu__cQA7X"};